
	import Component from 'vue-class-component'
	import moduleStore from './store/realVoicePay';
	import Vue from 'vue';
	import PageState from './store/state';
	import { Toast, Dialog } from "vant"
	import PayCard from '../../components/pay/pay.vue'
	@Component({
		components: {
			PayCard
		}
	})
	@moduleStore.initVuex({
		mutationNames:moduleStore.mutationNames,
		actionNames:moduleStore.actionNames
	})
	export default class realVoicePayPage extends Vue implements IvuePage<PageState>{
		state = new PageState();
		self:Vue = this;
		// service?: service;
		// controller?: controller;
		info:any = {
			anchorAvatar: '',
			anchorName: '',
			wordNum: '',
			orderPrice: ''
		};
		payType: number = 0
		id:any = 0;
		phone:any = "";
		openId:any = "";
		wwToken:any = "";
		code:any = "";
		second:any = 60;
		submit_status:any = 0;
		msg:any = "";
		captcha_value:any = "";
		showloginmodel:any = false;
		wwid:any = "";
		interval:any = "";
		paytrue:boolean = false;
		bridgeP: any = {
			appId: '',
			timeStamp: '', //时间戳，自1970年以来的秒数
			nonceStr: '', //随机串
			package: '',
			signType: '', //微信签名方式：
			paySign: ''
		}
		created(moduleData:IinjectDatas) {
			this.state = <PageState>moduleData.state;
		}
		mounted(moduleData:IinjectDatas){
			let str = this.__getUrlKeyWord('state') || '';
			let strarr = str.split("-");
			this.id = strarr[0] || '';
			this.wwToken = strarr[1] || '';
			this.code = this.__getUrlKeyWord('code') || '';
			this.phone = strarr[2] || '';
			this.showloginmodel = false;

			let that = this;
			//通过code获取用户的openid
			this.$http("getOpenId", {
				jsCode:this.code,
			}).then((res) => {
				if(res.code == 200){
					that.openId = res.data; 
					
				}else{
					Toast(res.message)
				}
			})
			// 通过wwtoken获取用户的手机号
			if(that.wwToken && !this.phone){
				this.getUserInfo();
			}
			console.log('this.getOrderInfo');
			this.$http("getOrderInfo", {orderId:this.id}).then((res) => {
				if(res.code == 1000){
					that.info = res.data;
				}else{
					Toast(res.message)
				}
			})
		}
		// 获取地址栏参数
		__getUrlKeyWord(keyWord) {
			let keyAfter = location.href.split(`${keyWord}=`)[1]
			let value = ''
			if (keyAfter) {
				value = keyAfter.split('&')[0]
			}
			return value
		}
		getUserInfo(){
			let that = this;
			this.$http("getUser", {
				origin:'voice-maker',
				wwToken:this.wwToken,
			}).then((res) => {
				if(res.code == 200){
					that.phone = res.data.phone;
					that.wwid = res.data.wwid
				}else{
					Toast(res.message)
				}
			})
		}
		showDialog() {
			this.showloginmodel = true
			console.log(this.showloginmodel, 'this.showloginmodel');
			
		}
		getphone(e){
			var myreg = /^[1][0-9]{10}$/;
			if (!myreg.test(this.phone)) {
				Toast({
					message: "请输入正确的手机号",
					icon: "none",
					duration: 2000,
					position: 'top'
				})
			   return false;
			}
			//手机号检测
			let that = this;
			this.$http("userExists", {
				phone:this.phone,
			}).then((res) => {
				console.log(res)
				console.log(res.data)
				if(res.code == 200){
					if(res.data == false){
						Dialog.confirm({
							title: '提示',
							message: '当前手机号未注册，请注册',
      						confirmButtonText: '注册',
							className: 'rel-dialog',
						}).then(() => {
							// on confirm
							that.showloginmodel = true;
						}).catch(() => {
							// on cancel
						})
					}
				}else{
					Toast(res.message)
				}
			})
		}
		
		pay(){
			if(this.paytrue) {
				return
			}
			this.paytrue = true
			var myreg = /^[1][0-9]{10}$/;
			if (!myreg.test(this.phone)) {
				Toast({
					message: "请输入正确的手机号",
					icon: "none",
					position: 'top',
				})
				this.paytrue = false
				return false;
			}
			if(this.openId == ""){
				Toast({
					message: "用户信息错误，请重新扫码",
					icon: "none",
					position: 'top',
				})
				this.paytrue = false
				return false;
			}
			//手机号检测
			this.$http("userExists", {
				phone:this.phone,
			}).then((res) => {
				if(res.code == 200){
					if(res.data == false){
						Dialog.confirm({
							title: '提示',
							message: '当前手机号未注册，请注册',
      						confirmButtonText: '注册',
							className: 'rel-dialog',
						}).then(() => {
							// on confirm
							this.showloginmodel = true;
						}).finally(() => {
							this.paytrue = false
						})
					}else{
						// ?wwToken=b232e02a8ef71b61d8a850f30c67b36b&orderId=20&openId=wf123r312fr
						//提交
						let params = {
							wwToken:this.wwToken,
							orderId:this.id,
							openId:this.openId,
							phone:this.phone,
							payType: this.payType
						}
						this.$http('wxPay', {
							...params
						}).then((response) => {
							this.paytrue = false
							console.log(response)
							if(response.code == 200){
								if(!res.data) return
								console.log(this.payType === 1, 'this.payType === 1');
								if(this.payType === 1) {
									(this.$refs.payCard as any).aliPay({...response.data, from: 'realPersonVoiceoverPay', wwid: this.wwid}, {
										path: '/realPersonPaySuccess',
										query: {
											anchorAvatar: this.info.anchorAvatar,
											anchorName: this.info.anchorName,
											wordNum: this.info.wordNum,
											orderPrice: this.info.orderPrice
										}
									})
									return
								}
								(this.$refs.payCard as any).wxPay({
									package: response.data.package,
									appId: response.data.appId,
									timeStamp: response.data.timeStamp,
									nonceStr: response.data.nonceStr,
									signType: response.data.signType,
									paySign: response.data.paySign
								}).then(() => {
									this.$router.push({
										path: '/realPersonPaySuccess',
										query: {
											anchorAvatar: this.info.anchorAvatar,
											anchorName: this.info.anchorName,
											wordNum: this.info.wordNum,
											orderPrice: this.info.orderPrice
										}
									})
								})
								/* if (typeof window.WeixinJSBridge === "undefined") {
									if (document.addEventListener) {
										(<any>document).addEventListener("WeixinJSBridgeReady", that.onBridgeReady(response), false);
									} else if ((<any>document).attachEvent) {
										(<any>document).attachEvent("WeixinJSBridgeReady", that.onBridgeReady(response));
										(<any>document).attachEvent("onWeixinJSBridgeReady", that.onBridgeReady(response));
									}
								} else {
									that.onBridgeReady(response);
								} */
							}else{
								Toast(response.message)
							}
						})
					}
				}else{
					Toast(res.message)
					this.paytrue = false
				}
			})
		}
		onBridgeReady(response) {
			window.WeixinJSBridge.invoke(
				"getBrandWCPayRequest", {
					"appId": response.data.appId, //公众号名称，由商户传入
					"timeStamp": response.data.timeStamp, //时间戳，自1970年以来的秒数
					"nonceStr": response.data.nonceStr, //随机串
					"package": response.data.package,
					"signType": response.data.signType, //微信签名方式：
					"paySign": response.data.paySign,//微信签名
					
				},
				function(res) {
					
					if (res.err_msg === "get_brand_wcpay_request:ok") {
						// 使用以上方式判断前端返回,微信团队郑重提示：
						//res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
					} else {
						// uni.hideLoading();
					}
					window.WeixinJSBridge.log(response.err_msg);
				}
			);
		}
		changPayMethod(v: number) {
			this.payType = v
		}
		getcode(){
			if (this.submit_status == 1) {
				return false;
			}
			if (!this.phone) {
				return	Toast('请输入手机号')
			}
			let that = this;
			//发送验证码
			that.$http("getCaptcha", {
				phone: this.phone,
				usage:'login',
				origin:'voice-maker'
			}).then((res) => {
				if (res.err_code == 0) {
					that.msg = res.msg;
					that.second = 60;
					that.submit_status = 1;
					that.interval = setInterval(function() {
						that.second--;
						if (that.second == 0) {
							that.submit_status = 0;
							clearInterval(that.interval);
						}
					}, 1000);
				} else if (res.err_code === 308) {
					Toast('验证码发送失败！请检查手机号是否正确！')
				} else {
					Toast(res.msg)
				}
			}).catch(() => {
				Toast('短信发送失败，请稍后再试')
				try {
		
				} catch (error) {
					console.log(error)
				}
				that.submit_status = 0;
			})
		}
		login(){
			let that = this;
			let promotsource = that.__getUrlKeyWord('promotsource')
			let promottype = that.__getUrlKeyWord('promottype')
			this.$http("realLogin", {
				phone: this.phone,
				captcha_value:this.captcha_value,
				app:'voice-maker',
				origin:'voice-maker',
				promotsource: promotsource,
				promottype: promottype
			}).then((res) => {
				if (res.err_code == 0) {
					localStorage.setItem("ww_token",res.token)
					that.asyncUser();
				} else {
					Toast(res.err_msg)
				}
			}).catch((res)=>{
				Toast(res.err_msg)
			})
		}
		asyncUser(){
			let that = this;
			this.$http("getUser", {
				origin:'voice-maker'
			}).then((res) => {
				if(res.code == 200){
					that.showloginmodel = false;
				}else{
					Toast(res.message)
				}
			})
		}
	
	}